<template>
  <div class="cart-option-item" :class="{ active }" @click="handleClick">
    <label class="cart-option-item__label">
      <div class="cart-option-item__name">{{ getNameByLocale(option) }}</div>
      <div class="cart-option-item__price">
        <div class="option-qty">
          <span v-if="qty > 1">{{ t('label.select_qty', [qty]) }}</span>
        </div>
        <span
          ><span v-if="price > 0">+ {{ formatCurrency(price) }}</span></span
        >
      </div>
    </label>

    <!-- 품절 -->
    <div v-if="option.IsSoldOut" class="cart-option-item__sold-out" @mouseup.stop>
      <img src="@/assets/images/icon-sold-out.svg" alt="Sold out" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import CartMenuOption from '@/interfaces/CartMenuOption';
  import SetMenu from '@/interfaces/SetMenu';
  import Topping from '@/interfaces/Topping';
  import { formatCurrency, getNameByLocale } from '@/utils';
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  interface Props {
    menuType: 'M' | 'S';
    option: Topping | SetMenu;
    selectedOptions: CartMenuOption[];
    price: number;
  }
  const props = defineProps<Props>();
  const emits = defineEmits(['onClick']);

  const { t } = useI18n();

  const active = computed(() =>
    props.selectedOptions.find(
      (item) =>
        item.OptionCode ===
        (props.menuType === 'M' ? (props.option as Topping).ToppingCode : (props.option as SetMenu).SetMenuCode),
    )
      ? true
      : false,
  );

  const qty = computed(() => {
    return props.selectedOptions.find((item) => item.OptionCode === (props.option as Topping).ToppingCode)?.Qty || 1;
  });

  const handleClick = () => emits('onClick');
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  .cart-option-item {
    position: relative;
    height: 100%;
    border-radius: 0.2239vw;
    box-shadow: vars.$base-box-shadow-black;
    overflow: hidden;
    &.active {
      &:before {
        position: absolute;
        top: -0.0746vw;
        left: -0.0746vw;
        width: calc(100% + 0.1493vw);
        height: calc(100% + 0.1493vw);
        border-radius: 0.2239vw;
        border: 0.2985vw solid var(--brand-primary);
        content: '';
        @media (max-width: vars.$md) {
          top: -1px;
          left: -1px;
          width: calc(100% + 2px);
          height: calc(100% + 2px);
          border-width: 1px;
        }
      }
      &:after {
        position: absolute;
        top: 0;
        right: 0;
        width: 2.6866vw;
        height: 2.2388vw;
        background: var(--brand-primary) url('@/assets/images/icon-check-white.svg') no-repeat center;
        background-size: 1.6418vw 1.1194vw;
        content: '';
        @media (max-width: vars.$md) {
          width: 20px;
          height: 20px;
          background-size: 10px;
        }
      }
    }
    .cart-option-item__label {
      position: relative;
      display: block;
      height: 100%;
      padding: 0.8955vw 1.194vw;
      border: 0.0746vw solid #dbdbdb;
      border-radius: 0.2239vw;
      @media (max-width: vars.$md) {
        padding: 10px 12px;
        border-width: 1px;
        border-radius: 3px;
      }
    }
    .cart-option-item__name {
      display: block;
      height: 3.2836vw;
      font-size: 1.6418vw;
      font-weight: 500;
      line-height: 1.6418vw;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      color: #545454;
      @media (max-width: vars.$md) {
        height: 28px;
        font-size: 14px;
        line-height: 14px;
      }
    }
    .cart-option-item__price {
      display: grid;
      grid-template-columns: auto auto;
      justify-content: space-between;
      height: 1.6418vw;
      color: var(--point-color-secondary);
      font-size: 1.3433vw;
      @media (max-width: vars.$md) {
        font-size: 12px;
      }
    }
    .cart-option-item__sold-out {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: rgba(137, 137, 137, 0.8);
      border: 0.1493vw solid rgba(255, 255, 255, 0.8);
      @media (max-width: vars.$md) {
        .sold-out__circle {
          width: 50px;
          height: 50px;
        }
        .sold-out__inner-circle {
          border: 1px solid #fff;
        }
        .sold-out__text {
          font-size: 12px;
        }
      }

      img {
        width: 40%;
      }
    }
  }
</style>
